import { render, staticRenderFns } from "./NewsFor.vue?vue&type=template&id=52f41c98"
import script from "./NewsFor.vue?vue&type=script&lang=js"
export * from "./NewsFor.vue?vue&type=script&lang=js"
import style0 from "./NewsFor.vue?vue&type=style&index=0&id=52f41c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports